import { EventEmitter, EventSubscription } from 'fbemitter';

interface Listener {
  eventName: string;
  cb: (...args: any[]) => void;
  subscription?: EventSubscription;
}

class EventBus extends EventEmitter {
  private eventListeners: Listener[] = [];

  override addListener(eventName: string, cb: (...args: any[]) => void) {
    const subscription = super.addListener(eventName, cb);

    this.eventListeners.push({
      eventName,
      cb,
      subscription,
    });

    return subscription;
  }

  removeListener(eventName: any, cb: any) {
    const foundListener = this.eventListeners.find(
      (listener) => listener.eventName === eventName && listener.cb === cb
    );

    if (foundListener) {
      foundListener.subscription?.remove();
      foundListener.subscription = undefined;
    }

    this.eventListeners = this.eventListeners.filter(
      (listener) => listener.subscription !== undefined
    );
  }
}

export default new EventBus();

export const SpinnerEventBus = new EventBus();
